import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["href"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'SpriteIcons',
    props: {
        name: {},
        className: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(props.className),
                height: "100%",
                width: "100%"
            }, [
                _createElementVNode("use", {
                    href: `/icons/sprite.svg#${props.name}`
                }, null, 8, _hoisted_1)
            ], 2));
        };
    }
});
